<template>
  <div id="SignUpForm">
    <AccountProfile
      ref="accountProfile"
      :organizationName="organizationName"
      :groupName="groupName"
      :organizationLogo="organizationLogo"
      @on-validate="mergePartialModels"
    />

    <div class="wizard-footer">
      <p v-if="apiErrors.REGISTER" style="color: #dc3545">
        REGISTER: {{ apiErrors.REGISTER }}
      </p>

      <p v-if="apiErrors.LOG_IN" style="color: #dc3545">
        LOG_IN: {{ apiErrors.LOG_IN }}
      </p>
      <TMGeneralButton
        @click.native="registerAndLogin('accountProfile')"
        text="CREATE MY ACCOUNT"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Api from "@/services/api";
import AccountProfile from "@/components/signUpForm/AccountProfile";
import TMGeneralButton from "@/components/common/TMGeneralButton";
import { normalizeUserData, changeToInitialCaps} from "@/services/utils";

export default {
  name: "SignUpForm",
  props: ["id"],
  components: {
    AccountProfile,
    TMGeneralButton,
  },
  data() {
    return {
      finalModel: {},
      organizationName: "",
      groupName: "",
      organizationLogo: "",
    };
  },
  computed: {
    ...mapState(["apiErrors", "currentUser"]),
  },
  methods: {
    ...mapActions(["CLEAR_API_ERRORS", "REGISTER", "LOG_IN"]),
    registerAndLogin() {
      var refToValidate = this.$refs["accountProfile"];
      return new Promise((resolve, reject) => {
        if (refToValidate.validate()) {
          // Prepare data for user registration (sign up).
          let registrationInfo = {
            full_name: changeToInitialCaps(refToValidate.$data.form.full_name),
            email: refToValidate.$data.form.email,
            password: refToValidate.$data.form.password,
          };
          registrationInfo = {
            user: { ...registrationInfo, type: "Presenter" },
          };
          registrationInfo = {
            ...registrationInfo,
            group_token: this.id,
          };
          // Call signup service.
          this.REGISTER(registrationInfo).then(
            (response) => {
              // Successful signup, then login the user
              let loginCredentials = {};
              loginCredentials.email = refToValidate.$data.form.email;
              loginCredentials.password = refToValidate.$data.form.password;
              loginCredentials = normalizeUserData(loginCredentials);
              // Call login service.
              this.LOG_IN(loginCredentials).then(
                (response) => {
                  // If successful login, the state 'currentUser' will be set and user
                  // will be redirected to Dashboard.
                  // @see watch
                  resolve(true);
                },
                (error) => {
                  console.log(error);
                  reject(error);
                }
              );
            },
            (error) => {
              console.log("!!!error", error.response.data);
              reject(error);
            }
          );
          this.$emit("on-validate", this.registrationInfo, true);
          resolve(true);
        }
      });
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model);
      }
    },
  },
  watch: {
    currentUser() {
      if (this.currentUser) this.$router.push({ name: "UserDashboard" });
    },
  },
  mounted() {
    this.CLEAR_API_ERRORS();
    Api()
      .get("groups/basic_info", {
        params: {
          token: this.id,
        },
      })
      .then((res) => {
        this.organizationName = res.data.organization || [];
        this.groupName = res.data.name || [];
        this.organizationLogo = res.data.org_logo || [];
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
<style lang="less">
@import "../../assets/components/signUpForm/SignUpFormGroup.less";
</style>
